import FlexContainer, { FlexDirection, HorizontalAlign } from './FlexContainer';

export default FlexContainer;

export { FlexContainer, FlexDirection, HorizontalAlign };
